import { baseUrlEndpoint, baseUrlPattern, resolveBaseUrl } from "../baseUrl";
import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";
import { cohereUsage } from "./usage";

const DEFAULT_COHERE_BASE_URL = "https://api.cohere.com/v1";

export const cohere = defineConnector({
  identifier: "cohere",
  name: "Cohere",
  tagLine: "AI models and embeddings",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: ({ baseUrl }) =>
    baseUrlPattern(baseUrl, DEFAULT_COHERE_BASE_URL),
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [API keys](https://dashboard.cohere.com/api-keys) in the Cohere dashboard and create a new key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "url",
          label: "Base URL (optional)",
          placeholder: DEFAULT_COHERE_BASE_URL,
          defaultValue: DEFAULT_COHERE_BASE_URL,
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "Leave blank for the default Cohere API endpoint.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) =>
      baseUrlEndpoint(baseUrl, DEFAULT_COHERE_BASE_URL, "/models"),
  },
  publicEnvVars: ({ baseUrl }) => ({
    COHERE_BASE_URL: resolveBaseUrl(baseUrl, DEFAULT_COHERE_BASE_URL),
  }),
  usageHint: () =>
    "Use process.env.COHERE_BASE_URL as the Cohere API base URL. Pass a placeholder API key; the proxy injects the real key from the connected app.",
  usage: cohereUsage(),
});
